const storageKey = 'walmart-oauth-handoff';

/**
 * Carries the walmartCallbackUri and clientType that Walmart Seller Center appends to our App
 * Login URL across the login redirect.
 *
 * sessionStorage rather than authStore.signInRedirect: that field is an in-memory observable, so it
 * cannot survive the full page navigation Walmart's redirect forces, and AppLoginViewStore
 * overwrites it with a role home page on every login. sessionStorage is also tab scoped, which is
 * exactly the lifetime of one connect attempt.
 */
const walmartHandoff = {
	/**
	 * Reads the parameters straight off window.location instead of a route's queryParams, because
	 * the App Login URL registered with Walmart is the plain login page: the first router
	 * transition drops the query string and no Walmart aware view store ever mounts. This also
	 * keeps working if the registered URL changes.
	 */
	capture() {
		try {
			const queryParams = new URLSearchParams(window.location.search);
			const walmartCallbackUri = queryParams.get('walmartCallbackUri');
			const clientType = queryParams.get('clientType');
			if (walmartCallbackUri === null && clientType === null) {
				return;
			}
			sessionStorage.setItem(storageKey, JSON.stringify({ walmartCallbackUri, clientType }));
		} catch (err) {
			// Private browsing modes can reject sessionStorage writes. The flow still works, it just
			// falls back to the server side configured authorize URL and client type.
		}
	},

	read() {
		try {
			const raw = sessionStorage.getItem(storageKey);
			return raw === null ? null : JSON.parse(raw);
		} catch (err) {
			return null;
		}
	},

	clear() {
		try {
			sessionStorage.removeItem(storageKey);
		} catch (err) {
			// Nothing to do; the entry expires with the tab regardless.
		}
	},
};

export default walmartHandoff;
